export var IMembership;
(function (IMembership) {
    let CancelReason;
    (function (CancelReason) {
        /**
         * Brands I shop aren't covered
         */
        CancelReason["BRAND_COVERAGE"] = "BRAND_COVERAGE";
        /**
         * I haven't saved enough to justify the membership
         */
        CancelReason["NOT_ENOUGH_SAVING"] = "NOT_ENOUGH_SAVING";
        /**
         * Program benefits aren't that useful to me
         */
        CancelReason["NOT_ENOUGH_BENEFIT"] = "NOT_ENOUGH_BENEFIT";
        /**
         * I'm not ordering enough on Faire
         */
        CancelReason["LOW_ORDER_VOLUME"] = "LOW_ORDER_VOLUME";
        /**
         * I don't have the budget available
         */
        CancelReason["NO_BUDGET"] = "NO_BUDGET";
        /**
         * Other (please specify):
         */
        CancelReason["OTHER"] = "OTHER";
        /**
         * Retailer is blacklisted on renewal
         */
        CancelReason["BLACKLISTED"] = "BLACKLISTED";
        /**
         * Retailer is bankrupted on renewal
         */
        CancelReason["BANKRUPTED"] = "BANKRUPTED";
        /**
         * Retailer identity is not confirmed on renewal
         */
        CancelReason["IDENTITY_NOT_CONFIRMED"] = "IDENTITY_NOT_CONFIRMED";
        /**
         * Retailer claimed Shopify offer on renewal
         */
        CancelReason["SHOPIFY_OFFER_CLAIMED"] = "SHOPIFY_OFFER_CLAIMED";
        /**
         * Membership canceled by admin upon request
         */
        CancelReason["CANCELED_BY_ADMIN"] = "CANCELED_BY_ADMIN";
        /**
         * Auto Enrolled free trial ended
         */
        CancelReason["AUTO_ENROLLED_TRIAL_ENDED"] = "AUTO_ENROLLED_TRIAL_ENDED";
    })(CancelReason = IMembership.CancelReason || (IMembership.CancelReason = {}));
    let Type;
    (function (Type) {
        /**
         * Faire Direct
         * @deprecated
         */
        Type["ELEVATE"] = "ELEVATE";
        /**
         * Insider
         */
        Type["SELECT"] = "SELECT";
    })(Type = IMembership.Type || (IMembership.Type = {}));
    let State;
    (function (State) {
        /**
         * We aren't charging the retailer/brand, until the current period ends.
         */
        State["TRIALING"] = "TRIALING";
        State["ACTIVE"] = "ACTIVE";
        /**
         * There is a failed payment for this membership.
         */
        State["UNPAID"] = "UNPAID";
        State["CANCELED"] = "CANCELED";
        State["PAUSED"] = "PAUSED";
        State["AUTO_ENROLLED_TRIAL"] = "AUTO_ENROLLED_TRIAL";
    })(State = IMembership.State || (IMembership.State = {}));
    let ActionAtPeriodEnd;
    (function (ActionAtPeriodEnd) {
        ActionAtPeriodEnd["ACTION_AT_PERIOD_END_UNKNOWN"] = "ACTION_AT_PERIOD_END_UNKNOWN";
        ActionAtPeriodEnd["RENEW"] = "RENEW";
        ActionAtPeriodEnd["CANCEL"] = "CANCEL";
        ActionAtPeriodEnd["PAUSE"] = "PAUSE";
    })(ActionAtPeriodEnd = IMembership.ActionAtPeriodEnd || (IMembership.ActionAtPeriodEnd = {}));
    /**
     * How often we should charge for the subscription.
     */
    let ChargeInterval;
    (function (ChargeInterval) {
        /**
         * A month in this situation is 30 days.
         */
        ChargeInterval["MONTH"] = "MONTH";
        /**
         * A year in this situation is 365 days.
         */
        ChargeInterval["YEAR"] = "YEAR";
    })(ChargeInterval = IMembership.ChargeInterval || (IMembership.ChargeInterval = {}));
    let Channel;
    (function (Channel) {
        Channel["CHANNEL_UNKNOWN"] = "CHANNEL_UNKNOWN";
        Channel["SHOPIFY"] = "SHOPIFY";
        Channel["AUTOMATIC_FREE_TRIAL"] = "AUTOMATIC_FREE_TRIAL";
        Channel["AUTOMATIC_FREE_TRIAL_RENEWAL"] = "AUTOMATIC_FREE_TRIAL_RENEWAL";
        Channel["MARKETING_PAGE"] = "MARKETING_PAGE";
        Channel["SHOPPING_BAG"] = "SHOPPING_BAG";
        Channel["BRAND_PAGE"] = "BRAND_PAGE";
        Channel["PDP"] = "PDP";
        Channel["CHECKOUT"] = "CHECKOUT";
        Channel["CX_ADMIN"] = "CX_ADMIN";
        Channel["HOMEPAGE"] = "HOMEPAGE";
        Channel["MOBILE_BANNER"] = "MOBILE_BANNER";
    })(Channel = IMembership.Channel || (IMembership.Channel = {}));
    /**
     * Return an instance of IMembership with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IMembership.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IMembership || (IMembership = {}));
